module.exports = __webpack_public_path__ + "media/application/images/2018/anchor-heading-dropdown-708ef80a6a8e2771291a15573ca04015.svg";